import React from 'react';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import { IconProps } from '../types';
const Recommendations = ({
  width = '18px',
  height = '21px',
  color = '#dededf'
}: IconProps) => {
  return (
    <TrendingUpIcon
      width={width}
      height={height}
      style={{ color: color, strokeWidth: '1' }}
    />
  );
};

export default Recommendations;
